<div class="filters">
  <ssg-side-filter (apply)="applyEdits()" (reset)="clearEditFilters()" (toggle)="toggleFilters($event)" [isDisabled]="!editFilters" [isInvalid]="!editFilters || editFilters.isFormInvalid() || isWorking" class="flex-column">
    <div *ngIf="editFilters" class="flex-fill flex-column">
      <ukg-popover #quickFiltersTooltip>
        <span>
          <b><span translate>EMPLOYEE_PAYS.FILTER_QUICK_FILTERS_LABEL</span></b>
          <br />
          <p translate>EMPLOYEE_PAYS.FILTER_QUICK_FILTERS_TOOLTIP</p>
         
          <ukg-list>
            <ukg-list-item>
              <p [innerHtml]="'EMPLOYEE_PAYS.FILTER_QUICK_FILTERS_TOOLTIP_PAYS_WITH_STOPS' | translate"></p>
            </ukg-list-item>
            <ukg-list-item>
              <p [innerHtml]="'EMPLOYEE_PAYS.FILTER_QUICK_FILTERS_TOOLTIP_PAYS_WITHOUT_STOPS' | translate"></p>
            </ukg-list-item>
            <ukg-list-item>
              <p [innerHtml]="'EMPLOYEE_PAYS.FILTER_QUICK_FILTERS_TOOLTIP_ALL_PAYS' | translate"></p>
            </ukg-list-item>
          </ukg-list>
        </span>
      </ukg-popover>
                 
      <ukg-icon name="help" (click)="quickFiltersTooltip.present($event.target)"></ukg-icon>
      <div class="wrap-container vertical-spacing">
        <div style="display:flex">
            <ukg-input-container [block]="true" [size]="medium">
              <div text-wrap data-automation="quick_filters_label"
              translate>EMPLOYEE_PAYS.FILTER_QUICK_FILTERS_SHOW_LABEL</div>
              <ukg-select data-automation="quick_filters_dropdown" [disabled]="isWorking" [multiple]="false" [(ngModel)]="selectedView" bindLabel="localizedName">
              <ukg-select-option *ngFor="let item of allViews" [value]="item" [label]="item.localizedName" ></ukg-select-option>
              </ukg-select>
            </ukg-input-container>
            
          <!-- </div> -->
        </div> 
      </div>
      <div class="wrap-container vertical-spacing fontstyling flex-row flex-gap-5pct">
        <div class="partial-width flex-column flex-gap-5pct">
          <div class="pay-tooltip">
            <span class="text-muted pay-spacing" data-automation="pay_date_from_edit_label" translate>EMPLOYEE_PAYS.PAY_DATE_FROM_LABEL</span>
              <ukg-popover #payDateFromTooltip>
              <span>
                <p [innerHtml]=" 'EMPLOYEE_PAYS.PAY_DATE_FROM_TOOLTIP' | translate " data-automation="pay_date_from_tooltip_text"></p>
              </span>
              </ukg-popover>
            <ukg-icon name="help" (click)="payDateFromTooltip.present($event.target)" data-automation="pay_date_from_tooltip_icon"></ukg-icon>
          </div>
          <div>
            <ssg-date-picker class="right" data-automation="pay_date_from_picker" [(ngModel)]="editFilters.dashboardFilters.payDate" [minDate]="minDate" [hasValidationError]="editFilters.isFromDateAfterToDate()" (invalidDateChanged)="editFilters.fromDateInvalid = $event" justify="right"></ssg-date-picker>
          </div>
        </div>
        <div class="partial-width flex-column flex-gap-5pct">
          <div class="pay-tooltip">
            <span class="text-muted pay-spacing" data-automation="pay_date_to_edit_label"
              translate>EMPLOYEE_PAYS.PAY_DATE_TO_LABEL</span>
            <ukg-popover #payDateToTooltip>
              <span>
                <p [innerHtml]=" 'EMPLOYEE_PAYS.PAY_DATE_TO_TOOLTIP' | translate " data-automation="pay_date_to_tooltip_text"></p>
              </span>
              </ukg-popover>
            
            <ukg-icon name="help" (click)="payDateToTooltip.present($event.target)"  data-automation="pay_date_to_tooltip_icon"></ukg-icon>
          </div>
          <div>
            <ssg-date-picker data-automation="pay_date_to_picker" [(ngModel)]="editFilters.payDateTo" [minDate]="minDate" [hasValidationError]="editFilters.isFromDateAfterToDate()" (invalidDateChanged)="editFilters.toDateInvalid = $event" justify="right"></ssg-date-picker>
          </div>
        </div>
        <ukg-label [hidden]="!editFilters.isFromDateAfterToDate()" class="text-danger" translate>
          EMPLOYEE_PAYS.FILTER_FROM_DATE_AFTER_TO_DATE</ukg-label>
        <ukg-label [hidden]="!editFilters.areRequiredFieldsMissingForDates()" class="text-danger" translate>
          EMPLOYEE_PAYS.FILTER_DIFFERENT_DATES</ukg-label>
      </div>
      <div class="wrap-container vertical-spacing flex-row flex-gap-5pct">
       
        <ukg-input-container [block]="true" [size]="medium" data-automation="pay_info_filters_payroll_type_edit_dropdown">
          <div text-wrap data-automation="payroll_type_edit_label" translate>AT_A_GLANCE.PAYROLL_TYPE_LABEL</div>
          <ukg-select  [multiple]="false" [compareWith]="ukgSelectCompareWith"
          bindLabel="localizedName" [(ngModel)]="payrollType">
         
            <ukg-select-option *ngFor="let item of allPayrollTypes" [value]="item.value" [label]="item.localizedName"></ukg-select-option>
          </ukg-select>
        </ukg-input-container>

      </div>
      <div class="wrap-container vertical-spacing flex-row flex-gap-5pct">
        
        <ukg-input-container [block]="true" [size]="medium">
          <div text-wrap data-automation="pay_group_edit_label" translate>AT_A_GLANCE.PAY_GROUP_LABEL</div>
        <ukg-select data-automation="pay_group_edit_dropdown" placeholder="{{ 'AT_A_GLANCE.PAY_GROUP_PLACEHOLDER' | translate}}" [disabled]="!allPayGroups.length"

        [multiple]="true" searchPlaceholder="{{'EMPLOYEE_PAYS.SEARCH' | translate}}" [(ngModel)]="editFilters.dashboardFilters.payGroups" bindLabel="code">
         <ukg-select-option *ngFor="let item of allPayGroups"  [value]="item" [label]="item.code" ></ukg-select-option>
        </ukg-select>
      </ukg-input-container>
      </div>
      <div class="wrap-container vertical-spacing fontstyling flex-row flex-gap-5pct">
        <div class="flex-100">
          <div class="text-muted" data-automation="firstname_edit_label" translate>EMPLOYEE_PAYS.FIRSTNAME_LABEL</div>
          <div [ngClass]="{'has-danger': editFilters.areRequiredFieldsMissingForDates()}">
            <ssg-multi-text data-automation="first_name_multiselect" [(ngModel)]="editFilters.firstNames"
              class="filters-input" placeholder="{{ 'EMPLOYEE_PAYS.FIRST_NAME_PLACEHOLDER' | translate }}">
            </ssg-multi-text>
          </div>
        </div>
      </div>
      <div class="wrap-container vertical-spacing fontstyling flex-row flex-gap-5pct">
        <div class="flex-100">
          <div class="text-muted" data-automation="lastname_edit_label" translate>EMPLOYEE_PAYS.LASTNAME_LABEL</div>
          <div [ngClass]="{'has-danger': editFilters.areRequiredFieldsMissingForDates()}">
            <ssg-multi-text data-automation="last_name_multiselect" [(ngModel)]="editFilters.lastNames"
              class="filters-input" placeholder="{{ 'EMPLOYEE_PAYS.LAST_NAME_PLACEHOLDER' | translate }}">
            </ssg-multi-text>
          </div>
        </div>
      </div>
      <div class="wrap-container vertical-spacing fontstyling flex-row flex-gap-5pct">
        <div class="flex-100">
          <div class="text-muted" data-automation="employee_number_edit_label" translate>
            EMPLOYEE_PAYS.EMPLOYEE_NUMBER_LABEL</div>
          <div [ngClass]="{'has-danger': editFilters.areRequiredFieldsMissingForDates()}">
            <ssg-multi-text data-automation="employee_id_multiselect" [(ngModel)]="editFilters.employeeNumbers"
              class="filters-input" placeholder="{{ 'EMPLOYEE_PAYS.EMPLOYEE_ID_PLACEHOLDER' | translate }}">
            </ssg-multi-text>
          </div>
        </div>
      </div>
      
      
      <div class="wrap-container vertical-spacing fontstyling flex-row flex-gap-5pct">
        <div class="flex-100">
          <div class="text-muted" data-automation="payment_type_edit_label" translate>EMPLOYEE_PAYS.PAYMENT_TYPE_LABEL
          </div>
          <div class="flex-row">
            <div style="min-width:50%">
                <ukg-checkbox [disabled]="false" [fullWidth]="false" [roundedCorners]="true"
                [(ngModel)]="editFilters.includeCheck" data-automation="payment_type_include_check">
                <span>Check</span> 
               </ukg-checkbox> 
            </div>
            <div style="min-width:50%">
           
              <ukg-checkbox [disabled]="false" [fullWidth]="false" [roundedCorners]="true"
                [(ngModel)]="editFilters.includeDirectDeposit" data-automation="payment_type_include_direct-deposit">
                <span>Direct Deposit</span> 
               </ukg-checkbox>
            </div>
          </div>
        </div>
      </div>
      <div class="wrap-container vertical-spacing fontstyling flex-row flex-gap-5pct">
        <div class="flex-100">
          <div>
           
            <ukg-input-container data-automation="amount_input">
            <ukg-label class="text-muted" data-automation="amount_edit_label" translate>EMPLOYEE_PAYS.AMOUNT_LABEL
            </ukg-label>

              <ukg-input class="filters-input" type="text" [ngModel]="formattedAmount"
                [ngModelOptions]="{updateOn:'blur'}" (ngModelChange)="amountChanged($event)"
                [ngClass]="{'has-danger': editFilters.isAmountTooBig() || editFilters.isAmountTooLow()}"></ukg-input>
            </ukg-input-container>
          </div>
          
          <ukg-label data-automation="amount_too_big_error" *ngIf="editFilters.isAmountTooBig()" class="text-danger"
            translate [translateParams]="{amount: 10000000000000.00 | ulticurrency:'1.02':undefined:true}">
            EMPLOYEE_PAYS.FILTER_AMOUNT_MAX
          </ukg-label>
          <ukg-label data-automation="amount_too_low_error" *ngIf="editFilters.isAmountTooLow()" class="text-danger"
            translate [translateParams]="{amount: -10000000000000.00 | ulticurrency:'1.02':undefined:true}">
            EMPLOYEE_PAYS.FILTER_AMOUNT_MIN
          </ukg-label>
        </div>
      </div>
      <div class="wrap-container vertical-spacing fontstyling flex-row flex-gap-5pct">
        <div class="flex-100">
         
          <div [ngClass]="{'has-danger': editFilters.areRequiredFieldsMissingForDates()}">
         
            <ukg-input-container data-automation="item_number_input"> 
            <ukg-label class="text-muted" data-automation="item_number_edit_label" translate>
              EMPLOYEE_PAYS.ITEM_NUMBER_LABEL</ukg-label>

              <ukg-input class="filters-input"  type="text"
                [(ngModel)]="editFilters.itemNumber"></ukg-input>
            </ukg-input-container>
          </div>
        </div>
      </div>
        
      <div *ngIf="isStopPaymentRequestEnabled" class="wrap-container vertical-spacing flex-row flex-gap-5pct">
        
        <ukg-input-container [block]="true" [size]="medium">
          <div text-wrap  data-automation="pay_group_edit_label" translate>EMPLOYEE_PAYS.STATUS_LABEL</div>
          <ukg-select data-automation="status_edit_dropdown" [multiple]="true" searchPlaceholder="{{'EMPLOYEE_PAYS.SEARCH' | translate}}" [selectState]="'secondary'"
           placeholder="{{ 'EMPLOYEE_PAYS.STATUS_PLACEHOLDER' | translate }}" [disabled]="!availableStatuses.length" [(ngModel)]="editFilters.statuses" bindLabel="label"
           bindValue="value" [compareWith]="ukgSelectCompareWith">
            <ukg-select-option *ngFor="let item of availableStatuses" [value]="item.value" [label]="item.label | translate">
            </ukg-select-option>
          </ukg-select>
        </ukg-input-container>
        
      </div>
    </div>
  </ssg-side-filter>
</div>